/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  LicenseCreate,
  LicenseRead,
  LicenseUpdate,
  PaginatedLicensesResponse,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    LicenseCreateFromJSON,
    LicenseCreateToJSON,
    LicenseReadFromJSON,
    LicenseReadToJSON,
    LicenseUpdateFromJSON,
    LicenseUpdateToJSON,
    PaginatedLicensesResponseFromJSON,
    PaginatedLicensesResponseToJSON,
} from '../models/index';

export interface CreateLicenseRequest {
    licenseCreate: LicenseCreate;
}

export interface DeleteLicenseRequest {
    licenseId: string;
}

export interface GetLicenseRequest {
    licenseId: string;
}

export interface GetLicensesRequest {
    skip?: number;
    limit?: number;
    search?: string | null;
    status?: GetLicensesStatusEnum;
    assigned?: boolean | null;
    available?: boolean | null;
}

export interface UpdateLicenseRequest {
    licenseId: string;
    licenseUpdate: LicenseUpdate;
}

export interface ValidateLicenseRequest {
    licenseKey: string;
}

/**
 * 
 */
export class LicensesApi extends runtime.BaseAPI {

    /**
     * Create a new license.  **Authorization:** Superadmins only.  Args:     license_data: License data to create     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Created license  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 400 if license key already exists
     * Create License
     */
    async createLicenseRaw(requestParameters: CreateLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LicenseRead>> {
        if (requestParameters['licenseCreate'] == null) {
            throw new runtime.RequiredError(
                'licenseCreate',
                'Required parameter "licenseCreate" was null or undefined when calling createLicense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/licenses/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LicenseCreateToJSON(requestParameters['licenseCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LicenseReadFromJSON(jsonValue));
    }

    /**
     * Create a new license.  **Authorization:** Superadmins only.  Args:     license_data: License data to create     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Created license  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 400 if license key already exists
     * Create License
     */
    async createLicense(requestParameters: CreateLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LicenseRead> {
        const response = await this.createLicenseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a license that no organization uses.  **Authorization:** Superadmins only.  Args:     license_id: ID of license to delete     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Success message  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if license not found     HTTPException: 409 if an organization uses the license
     * Delete License
     */
    async deleteLicenseRaw(requestParameters: DeleteLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: string | null; }>> {
        if (requestParameters['licenseId'] == null) {
            throw new runtime.RequiredError(
                'licenseId',
                'Required parameter "licenseId" was null or undefined when calling deleteLicense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/licenses/{license_id}`.replace(`{${"license_id"}}`, encodeURIComponent(String(requestParameters['licenseId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a license that no organization uses.  **Authorization:** Superadmins only.  Args:     license_id: ID of license to delete     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Success message  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if license not found     HTTPException: 409 if an organization uses the license
     * Delete License
     */
    async deleteLicense(requestParameters: DeleteLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: string | null; }> {
        const response = await this.deleteLicenseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a single license by ID.  **Authorization:** Superadmins only.  Args:     license_id: ID of license to retrieve     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     License details  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if license not found
     * Get License
     */
    async getLicenseRaw(requestParameters: GetLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LicenseRead>> {
        if (requestParameters['licenseId'] == null) {
            throw new runtime.RequiredError(
                'licenseId',
                'Required parameter "licenseId" was null or undefined when calling getLicense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/licenses/{license_id}`.replace(`{${"license_id"}}`, encodeURIComponent(String(requestParameters['licenseId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LicenseReadFromJSON(jsonValue));
    }

    /**
     * Get a single license by ID.  **Authorization:** Superadmins only.  Args:     license_id: ID of license to retrieve     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     License details  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if license not found
     * Get License
     */
    async getLicense(requestParameters: GetLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LicenseRead> {
        const response = await this.getLicenseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List licenses newest first, with the organization each one is assigned to.  **Authorization:** Superadmins only.  Args:     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)     skip: Number of records to skip     limit: Maximum number of records to return     search: Case-insensitive match on the key or the notes     license_status: active, expiring, expired or inactive (query parameter `status`)     assigned: Filter by assignment to an organization     available: Filter by whether an organization update would accept the license  Returns:     The page of licenses with the total matching the filters  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin
     * Get Licenses
     */
    async getLicensesRaw(requestParameters: GetLicensesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedLicensesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['assigned'] != null) {
            queryParameters['assigned'] = requestParameters['assigned'];
        }

        if (requestParameters['available'] != null) {
            queryParameters['available'] = requestParameters['available'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/licenses/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedLicensesResponseFromJSON(jsonValue));
    }

    /**
     * List licenses newest first, with the organization each one is assigned to.  **Authorization:** Superadmins only.  Args:     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)     skip: Number of records to skip     limit: Maximum number of records to return     search: Case-insensitive match on the key or the notes     license_status: active, expiring, expired or inactive (query parameter `status`)     assigned: Filter by assignment to an organization     available: Filter by whether an organization update would accept the license  Returns:     The page of licenses with the total matching the filters  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin
     * Get Licenses
     */
    async getLicenses(requestParameters: GetLicensesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedLicensesResponse> {
        const response = await this.getLicensesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing license.  **Authorization:** Superadmins only.  Args:     license_id: ID of license to update     license_update: Updated license data     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Updated license  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if license not found
     * Update License
     */
    async updateLicenseRaw(requestParameters: UpdateLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LicenseRead>> {
        if (requestParameters['licenseId'] == null) {
            throw new runtime.RequiredError(
                'licenseId',
                'Required parameter "licenseId" was null or undefined when calling updateLicense().'
            );
        }

        if (requestParameters['licenseUpdate'] == null) {
            throw new runtime.RequiredError(
                'licenseUpdate',
                'Required parameter "licenseUpdate" was null or undefined when calling updateLicense().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/licenses/{license_id}`.replace(`{${"license_id"}}`, encodeURIComponent(String(requestParameters['licenseId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LicenseUpdateToJSON(requestParameters['licenseUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LicenseReadFromJSON(jsonValue));
    }

    /**
     * Update an existing license.  **Authorization:** Superadmins only.  Args:     license_id: ID of license to update     license_update: Updated license data     session: Database session (injected)     current_user: Currently authenticated superadmin (injected)  Returns:     Updated license  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not a superadmin     HTTPException: 404 if license not found
     * Update License
     */
    async updateLicense(requestParameters: UpdateLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LicenseRead> {
        const response = await this.updateLicenseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate a license key.  **Authorization:** Any authenticated user.  Args:     license_key: License key to validate     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     License details if valid  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 404 if license key not found     HTTPException: 400 if license is not active or already used
     * Validate License
     */
    async validateLicenseRaw(requestParameters: ValidateLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LicenseRead>> {
        if (requestParameters['licenseKey'] == null) {
            throw new runtime.RequiredError(
                'licenseKey',
                'Required parameter "licenseKey" was null or undefined when calling validateLicense().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['licenseKey'] != null) {
            queryParameters['license_key'] = requestParameters['licenseKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/licenses/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LicenseReadFromJSON(jsonValue));
    }

    /**
     * Validate a license key.  **Authorization:** Any authenticated user.  Args:     license_key: License key to validate     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     License details if valid  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 404 if license key not found     HTTPException: 400 if license is not active or already used
     * Validate License
     */
    async validateLicense(requestParameters: ValidateLicenseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LicenseRead> {
        const response = await this.validateLicenseRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetLicensesStatusEnum = {
    Active: 'active',
    Expiring: 'expiring',
    Expired: 'expired',
    Inactive: 'inactive'
} as const;
export type GetLicensesStatusEnum = typeof GetLicensesStatusEnum[keyof typeof GetLicensesStatusEnum];
